import { FaBell } from "react-icons/fa";
import Button from "../../../../components/Button.jsx";
import Status from "../../../../components/Status.jsx";
import Checkbox from "../../../../components/Checkbox.jsx";
import styles from "../css/reverseStock.module.css";

export function getListColumns(onView) {
  return [
    { header: "Script Number", accessor: "script" },
    {
      header: "",
      accessor: "issues",
      render: (value) => (
        <div className={styles.alertCell}>
          <span className={styles.alertBadge}>
            <FaBell className={styles.alertIcon} aria-label="alerts" />
            <span className={styles.alertCount}>{value}</span>
          </span>
        </div>
      ),
    },
    { header: "Date", accessor: "date" },
    {
      header: "Status",
      accessor: "status",
      render: (value) => <Status status={value} variant="process" />,
    },
    {
      header: "Action",
      accessor: "action",
      render: (_, row) => (
        <Button variant="primary" className={styles.viewBtn} onClick={() => onView(row)}>
          View More
        </Button>
      ),
    },
  ];
}

export function getHistoryColumns(onView) {
  return [
    { header: "Script Number", accessor: "script" },
    {
      header: "",
      accessor: "issues",
      render: (value) => (
        <div className={styles.alertCell}>
          <span className={styles.alertBadge}>
            <FaBell className={styles.alertIcon} aria-label="alerts" />
            <span className={styles.alertCount}>{value}</span>
          </span>
        </div>
      ),
    },
    { header: "Date", accessor: "date" },
    {
      header: "Status",
      accessor: "status",
      render: () => <span className={styles.ncndBadge}>NCND</span>,
    },
    {
      header: "Action",
      accessor: "action",
      render: (_, row) => (
        <Button variant="primary" className={styles.viewBtn} onClick={() => onView(row)}>
          View More
        </Button>
      ),
    },
  ];
}

export function getDetailColumns(detailsData, onToggleRow) {
  return [
    { header: "Drug Name", accessor: "drug" },
    { header: "Storage", accessor: "storage" },
    { header: "Active ingredient", accessor: "ingredient" },
    { header: "Nappi Code", accessor: "nappi" },
    { header: "Expiry Date", accessor: "expiry" },
    {
      header: "",
      accessor: "checked",
      render: (_, __, rowIndex) => (
        <Checkbox id={`detail-${rowIndex}`} checked={detailsData[rowIndex]?.checked || false} onChange={() => onToggleRow(rowIndex)} />
      ),
    },
  ];
}

export function getFrontShopDetailColumns(detailsData, onToggleRow) {
  return [
    { header: "Product Name", accessor: "product" },
    { header: "Shelve Number", accessor: "storage" },
    { header: "Category", accessor: "category" },
    { header: "Barcode", accessor: "barcode" },
    { header: "Nappi Code", accessor: "nappi" },
    { header: "Expiry Date", accessor: "expiry" },
    {
      header: "",
      accessor: "checked",
      render: (_, __, rowIndex) => (
        <Checkbox id={`detail-${rowIndex}`} checked={detailsData[rowIndex]?.checked || false} onChange={() => onToggleRow(rowIndex)} />
      ),
    },
  ];
}

export function getOtcDetailColumnsPending(detailsData, onToggleRow) {
  return [
    { header: "Drug Name", accessor: "drug" },
    { header: "Storage", accessor: "storage" },
    { header: "Active Ingredient", accessor: "ingredient" },
    { header: "Nappi Code", accessor: "nappi" },
    { header: "Barcode", accessor: "barcode" },
    { header: "Expiry Date", accessor: "expiry" },
    {
      header: "",
      accessor: "checked",
      render: (_, __, rowIndex) => (
        <Checkbox id={`detail-${rowIndex}`} checked={detailsData[rowIndex]?.checked || false} onChange={() => onToggleRow(rowIndex)} />
      ),
    },
  ];
}

export function getHistoryDetailColumns() {
  return [
    { header: "Drug Name", accessor: "drug" },
    { header: "Storage", accessor: "storage" },
    { header: "Active ingredient", accessor: "ingredient" },
    { header: "Nappi Code", accessor: "nappi" },
    { header: "Expiry Date", accessor: "expiry" },
  ];
}

export function getFrontShopHistoryDetailColumns() {
  return [
    { header: "Product Name", accessor: "product" },
    { header: "Shelve Number", accessor: "storage" },
    { header: "Category", accessor: "category" },
    { header: "Barcode", accessor: "barcode" },
    { header: "Expiry Date", accessor: "expiry" },
  ];
}

export function getOtcHistoryDetailColumns() {
  return [
    { header: "Drug Name", accessor: "drug" },
    { header: "Storage", accessor: "storage" },
    { header: "Active Ingredient", accessor: "ingredient" },
    { header: "Nappi Code", accessor: "nappi" },
    { header: "Expiry Date", accessor: "expiry" },
  ];
}
